import { AfterViewInit, Component, signal, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerComponent } from './core/components/spinner/spinner.component';
import { ToastService } from './shared/services/toast.service';
import { ToastComponent } from './core/components/toast/toast.component';
import '@iframe-resizer/child';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, SpinnerComponent, PdfViewerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  @ViewChild(SpinnerComponent) spinnerComponent?: SpinnerComponent;

  protected readonly title = signal('perfil-investimento-app');

  constructor(
    private toastService: ToastService,

  ) {}

  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toastComponent);
  }
}
